import { combineReducers } from 'redux'
import notifications from '../state/notifications'
import analyticsRegister from './analytics-register'
import application from './application'
import defaultRegister from './default-register'
import forgotPassword from './forgot-password'
import login from './login'
import registration from './registration'


const rootReducer = combineReducers({
    analyticsRegister,
    application,
    defaultRegister,
    forgotPassword,
    login,
    notifications,
    registration
})

export default rootReducer
